<template>
  <div>
    <p>Word {{ state.trial_index + 1 }} of {{ stage.trials.length }}</p>
    <div class="sound-row"><AudioPlayer :stage-id="stage.id" v-for="phoneme in trial.phonemes" :key="phoneme.id" :src="phoneme.audio" :label="phoneme.label" :material-id="phoneme.id" :disabled="disabled" @action="$emit('action', $event)" /></div>
    <p id="word-built">Your word · Tap a letter here to remove it.</p>
    <div class="word-slots" role="group" aria-labelledby="word-built">
      <button v-for="(id, index) in chosen" :key="id" class="letter-tile chosen" :disabled="disabled" :aria-label="`Remove ${letter(id)}`" @click="$emit('action', { type: 'tile_remove', index })">{{ letter(id) }}</button>
      <span v-for="n in trial.tiles.length - chosen.length" :key="`empty-${n}`" class="empty-tile" aria-label="Empty letter space">_</span>
    </div>
    <div class="tile-row" role="group" aria-label="Available letters"><button v-for="tile in trial.tiles" :key="tile.id" class="letter-tile" :disabled="disabled || chosen.includes(tile.id)" @click="$emit('action', { type: 'tile_add', tile_id: tile.id })">{{ tile.letter }}</button></div>
    <p class="muted">Recordings are not added yet. Your spelling is saved without an audio-based score.</p>
    <button v-if="state.trial_index < stage.trials.length - 1" :disabled="disabled || chosen.length !== trial.tiles.length" @click="$emit('action', { type: 'trial_next' })">Save word · Next word</button>
  </div>
</template>
<script>
import AudioPlayer from './AudioPlayer.vue';
export default {
  components: { AudioPlayer }, props: { stage: Object, state: Object, disabled: Boolean }, emits: ['action'],
  computed: { trial() { return this.stage.trials[this.state.trial_index]; }, chosen() { return this.state.words[this.trial.id]; } },
  methods: { letter(id) { return this.trial.tiles.find(tile => tile.id === id).letter; } }
};
</script>

